import React from "react";
import "./DemoCelebration.css";
import { t } from "../i18n";

interface Props {
  onClose: () => void;
}

// The "You got it!" moment — fires once, when the DJ has handled BOTH demo
// practice requests (accept one, decline the other). Pure celebration +
// orientation; no money language anywhere — the demos never touch earnings
// (see src/lib/demoRequest.ts). 1.5.1 redesign (founder: "modernize it, no
// emoji"): a green check medallion that draws itself, a recap of the two
// moves they just made, brand-colour confetti.
export default function DemoCelebration({ onClose }: Props) {
  return (
    <div className="demo-celebration-overlay" role="dialog" aria-modal="true" aria-label={t("demoCelebration.demoComplete")} onClick={onClose}>
      <div className="demo-celebration-card" onClick={(e) => e.stopPropagation()}>
        {/* CSS-only confetti burst — one pass, no library. */}
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} className={`demo-confetti demo-confetti-${i + 1}`} aria-hidden />
        ))}
        <div className="demo-cel-medal" aria-hidden>
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path className="demo-cel-check" d="M6 12.5l4 4L18 8.5" />
          </svg>
        </div>
        <h3 className="demo-celebration-title">{t("demoCelebration.youGotIt")}</h3>
        <p className="demo-celebration-sub">{t("demoCelebration.realRequestsWorkExactly")}</p>
        <div className="demo-cel-recap" aria-hidden>
          <span className="demo-cel-chip demo-cel-chip--yes">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
            {t("demoCelebration.accepted")}
          </span>
          <span className="demo-cel-chip demo-cel-chip--no">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11" /></svg>
            {t("demoCelebration.declined")}
          </span>
        </div>
        <p className="demo-celebration-note">{t("demoCelebration.shareYourQr")}</p>
        <button type="button" className="demo-celebration-btn" onClick={onClose}>
          {t("demoCelebration.letSGo")}
        </button>
      </div>
    </div>
  );
}
